import React from "react";

const ServiceTimeBased = () => {
  return (
    <>
      <svg
        width="120"
        height="129"
        viewBox="0 0 167 179"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_46888_68095)">
          <path d="M1 1H166V198.809H1V1Z" fill="#F8F8F8" />
          <path
            d="M147.38 110.636H18.7578V104.887C18.7578 99.1375 23.5216 94.4531 29.3681 94.4531H136.986C142.616 94.4531 147.38 98.9246 147.38 104.674V110.636Z"
            fill="#EEEEEE"
          />
          <path
            d="M18.7578 61.9688H43.6594M18.7578 72.7854H43.6594"
            stroke="#BFC7D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M29.1533 94.6719H137.205C142.834 94.6719 147.382 99.1433 147.382 104.679V151.097C147.382 156.633 142.834 161.105 137.205 161.105H29.1533C23.5234 161.105 18.9762 156.633 18.9762 151.097V104.892C18.7596 99.1433 23.3069 94.6719 29.1533 94.6719Z"
            stroke="#C9D1E3"
            stroke-miterlimit="10"
          />
          <path
            d="M31.5356 41.4339C38.4718 41.4339 44.0947 35.9047 44.0947 29.0841C44.0947 22.2635 38.4718 16.7344 31.5356 16.7344C24.5994 16.7344 18.9766 22.2635 18.9766 29.0841C18.9766 35.9047 24.5994 41.4339 31.5356 41.4339Z"
            stroke="#BFC7D9"
            stroke-width="2"
            stroke-miterlimit="10"
          />
          <path
            d="M125.078 24.1875V33.5563H123.129V24.1875H125.078ZM135.471 24.1875V33.5563H133.739L129.625 27.8073V33.5563H127.676V24.1875H129.408L133.523 29.9365V24.1875H135.471ZM139.586 24.1875L141.967 31.2141L144.349 24.1875H146.515L143.267 33.5563H140.668L137.42 24.1875H139.586Z"
            fill="#71778E"
          />
          <path
            d="M70.7268 161.517V95.2969M19.1914 110.415H147.164"
            stroke="#BFC7D9"
            stroke-miterlimit="10"
          />
        </g>
        <rect
          x="0.5"
          y="0.5"
          width="166"
          height="178"
          rx="16.5"
          stroke="#BFC7D9"
        />
        <defs>
          <clipPath id="clip0_46888_68095">
            <rect x="1" y="1" width="165" height="177" rx="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export default ServiceTimeBased;
